<template>
    <div class="Details">
    <section>
        <div class="x">
            <div class="boxx">
                <b-field position="is-right">
                        <p class="control">
                        <!-- <div class="is-pulled-right">
                            <b-button type="is-white">
                                <b>Unlimited labels</b>
                            </b-button>
                        </div> -->
                        </p>
                    </b-field>
                <!-- <h4 class="title is-4">
                    Define labels
                </h4> -->
                
                <div class="columns">
                    
                    <div class="column is-full">
                        <LabelsDefine :project="project" :records="records"/>
                    </div>
                </div>
                <!-- <div class="columns">
                    <div class="column is-full">
                        <hr>
                        <p class="subtitle is-5">
                            When labeling text data for classification, it is important to use descriptive and consistent labels that accurately represent the classes that the AI model will be trained to classify.
                        </p>
                        <b-image
                            class="is-pulled-center"
                            style="width: 30em"
                            :src="require('@/images/training-example.svg')">
                        </b-image>
                        <p class="subtitle is-5">
                            <i class="fas fa-check" aria-hidden="true"></i> Use clear and descriptive labels: Use labels that clearly describe the content of the text data. For example, if you are classifying news articles, use labels such as "politics", "sports", "entertainment", etc.
                        </p><p class="subtitle is-5">
                            <i class="fas fa-check" aria-hidden="true"></i> Use consistent labels: Ensure that labels are consistent across the dataset, and that each label accurately represents the class of the text data. Inconsistent or ambiguous labels can lead to errors in the AI model's predictions.
                        </p><p class="subtitle is-5">
                            <i class="fas fa-check" aria-hidden="true"></i> Avoid overlapping or ambiguous labels: Ensure that labels do not overlap or have unclear boundaries. For example, if you are classifying text data about food, avoid using labels such as "Italian" and "European" which could overlap. Instead, use more specific labels such as "pizza" and "paella".
                        </p><p class="subtitle is-5">
                            <i class="fas fa-check" aria-hidden="true"></i> Use hierarchical labels: If your dataset has multiple levels of classification, consider using hierarchical labels to represent the different levels. For example, if you are classifying movies, you could use a hierarchical label such as "genre/subgenre" to represent the different levels of classification.
                        </p><p class="subtitle is-5">
                            <i class="fas fa-check" aria-hidden="true"></i> Regularly review and update labels: As your dataset grows, it may be necessary to review and update labels to ensure that they accurately represent the classes of text data. Regularly reviewing and updating labels can help improve the accuracy of the AI model's predictions.
                        </p>
                    </div>
                </div> -->
                
                
              <br>
              
        </div>
        </div>
        
        
    </section>

    </div>
    
</template>
<script>
import ModalDataset from '@/components/DatasetIncrease.vue'
import ModalModel from '@/components/ModelCreateNew.vue'
import LabelsDefine from '@/components/LabelsDefine.vue'
import { isThenable } from '@sentry/utils';
   export default {
     props: ["project", "records", "currentUser", "filterId"],
     name: "Uploads",
     data: function() {
    return {
    }},
    components: {
      ModalDataset,
      ModalModel,
      LabelsDefine
    }
   };
</script>

<style lang="scss" scoped>
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>